import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Header } from "orcs-design-system";

const Logo = styled.img`
  ${(props) => props.styles}
`;

const HeaderPreview = ({ config }) => {
  const logo = config?.logoImage?.src ? <Logo {...config.logoImage} /> : null;

  return <Header logo={logo} appName={config?.appName ?? ""} />;
};

HeaderPreview.propTypes = {
  config: PropTypes.object,
};

export default HeaderPreview;
